// OneApp 리뉴얼 기본 JS
// 메뉴, 배너, 특장점 등 동적 UI 스크립트는 이곳에 작성

// 예시: 메뉴 클릭 이벤트
// document.querySelectorAll('nav a').forEach(function(item) {
//   item.addEventListener('click', function(e) {
//     // 메뉴 클릭 시 동작
//   });
// });

// 모달 관련 기능
document.addEventListener('DOMContentLoaded', function() {
  // 모달 HTML을 동적으로 생성
  const modalHTML = `
    <div id="termsModal" class="modal">
      <div class="modal-content">
        <div class="modal-header">
          <h2 id="modalTitle">약관</h2>
          <button class="modal-close" onclick="closeModal()">&times;</button>
        </div>
        <div class="modal-body" id="modalBody">
          <!-- 콘텐츠가 여기에 로드됩니다 -->
        </div>
        <div class="modal-footer">
          <button class="modal-btn modal-btn-secondary" onclick="closeModal()">취소</button>
          <button class="modal-btn modal-btn-primary" id="confirmBtn" onclick="confirmTerms()">확인</button>
        </div>
      </div>
    </div>
  `;
  
  // body에 모달 추가
  document.body.insertAdjacentHTML('beforeend', modalHTML);
});

// 현재 모달 타입을 저장하는 변수
let currentModalType = '';

// 모달 열기 함수
function openModal(type) {
  const modal = document.getElementById('termsModal');
  const modalTitle = document.getElementById('modalTitle');
  const modalBody = document.getElementById('modalBody');
  
  currentModalType = type; // 현재 모달 타입 저장
  
  if (type === 'terms') {
    modalTitle.textContent = '이용약관';
    loadTermsContent(modalBody);
  } else if (type === 'privacy') {
    modalTitle.textContent = '개인정보처리방침';
    loadPrivacyContent(modalBody);
  }
  
  modal.style.display = 'block';
  document.body.style.overflow = 'hidden'; // 배경 스크롤 방지
}

// 약관 확인 버튼 클릭 시 처리
function confirmTerms() {
  if (currentModalType === 'terms') {
    // 이용약관 체크박스 찾기 - 더 정확한 방법
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    for (let checkbox of checkboxes) {
      const parentLabel = checkbox.parentElement;
      if (parentLabel && parentLabel.tagName === 'LABEL' && parentLabel.textContent.includes('이용약관')) {
        checkbox.checked = true;
        // 체크박스 변경 이벤트 발생시키기
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        break;
      }
    }
  } else if (currentModalType === 'privacy') {
    // 개인정보처리방침 체크박스 찾기 - 더 정확한 방법
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    for (let checkbox of checkboxes) {
      const parentLabel = checkbox.parentElement;
      if (parentLabel && parentLabel.tagName === 'LABEL' && parentLabel.textContent.includes('개인정보처리방침')) {
        checkbox.checked = true;
        // 체크박스 변경 이벤트 발생시키기
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        break;
      }
    }
  }
  
  // 모달 닫기
  closeModal();
  
  // 사용자에게 피드백 제공
  if (currentModalType === 'terms') {
    showFeedback('이용약관에 동의하였습니다.');
  } else if (currentModalType === 'privacy') {
    showFeedback('개인정보처리방침에 동의하였습니다.');
  }
}

// 사용자 피드백 표시 함수
function showFeedback(message) {
  // 간단한 토스트 메시지 생성
  const toast = document.createElement('div');
  toast.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: #4caf50;
    color: white;
    padding: 12px 20px;
    border-radius: 4px;
    z-index: 10000;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
    transform: translateX(100%);
    transition: transform 0.3s ease;
  `;
  toast.textContent = message;
  
  document.body.appendChild(toast);
  
  // 애니메이션 효과
  setTimeout(() => {
    toast.style.transform = 'translateX(0)';
  }, 100);
  
  // 3초 후 제거
  setTimeout(() => {
    toast.style.transform = 'translateX(100%)';
    setTimeout(() => {
      document.body.removeChild(toast);
    }, 300);
  }, 3000);
}

// 모달 닫기 함수
function closeModal() {
  const modal = document.getElementById('termsModal');
  modal.style.display = 'none';
  document.body.style.overflow = 'auto'; // 배경 스크롤 복원
}

// 모달 외부 클릭 시 닫기
window.addEventListener('click', function(event) {
  const modal = document.getElementById('termsModal');
  if (event.target === modal) {
    closeModal();
  }
});

// ESC 키로 모달 닫기
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    closeModal();
  }
});

// 이용약관 내용 로드
function loadTermsContent(container) {
  container.innerHTML = `
    <div class="privacy-intro">
      주식회사 빌리언대부(이하 '회사')가 제공하는 주식담보대출 서비스를 이용해 주셔서 감사합니다. 본 약관은 회사와 이용자 간의 서비스 이용에 관한 제반 사항을 규정하고 있습니다.
    </div>
    
    <div class="rules-content">
      <h3>제1장 총칙</h3>
      <h4>제1조 (목적)</h4>
      <p>본 약관은 주식회사 빌리언대부(이하 "회사"라 함)가 제공하는 주식담보대출 서비스의 이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>
      
      <h4>제2조 (정의)</h4>
      <p>본 약관에서 사용하는 용어의 정의는 다음과 같습니다:</p>
      <ol>
        <li><strong>서비스:</strong> 회사가 제공하는 주식담보대출 관련 제반 서비스</li>
        <li><strong>회원:</strong> 회사의 서비스에 접속하여 본 약관에 따라 회사가 제공하는 서비스를 받는 자</li>
        <li><strong>아이디(ID):</strong> 회원의 식별과 서비스 이용을 위하여 회원이 정하고 회사가 승인하는 문자와 숫자의 조합</li>
        <li><strong>비밀번호:</strong> 회원이 부여받은 아이디와 일치되는 회원임을 확인하고 비밀보호를 위해 회원 자신이 정한 문자 또는 숫자의 조합</li>
      </ol>
      
      <h3>제2장 서비스 제공 및 이용</h3>
      <h4>제3조 (서비스의 제공)</h4>
      <ol>
        <li>회사는 회원에게 아래와 같은 서비스를 제공합니다:
          <ul>
            <li>주식담보대출 신청 및 승인 서비스</li>
            <li>대출금리 및 한도 조회 서비스</li>
            <li>상환 및 연장 신청 서비스</li>
            <li>기타 회사가 추가 개발하거나 다른 회사와의 제휴계약 등을 통해 회원에게 제공하는 일체의 서비스</li>
          </ul>
        </li>
        <li>회사는 서비스를 일정범위로 분할하여 각 범위별로 이용가능시간을 별도로 지정할 수 있습니다.</li>
      </ol>
      
      <h4>제4조 (서비스의 중단)</h4>
      <ol>
        <li>회사는 컴퓨터 등 정보통신설비의 보수점검·교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.</li>
        <li>회사는 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 회원 또는 제3자가 입은 손해에 대하여는 배상하지 않습니다.</li>
      </ol>
      
      <h3>제3장 회원가입 및 관리</h3>
      <h4>제5조 (회원가입)</h4>
      <ol>
        <li>회원가입은 신청자가 온라인으로 회사가 정한 가입양식에 따라 회원정보를 기입한 후 본 약관에 동의한다는 의사표시를 함으로써 신청합니다.</li>
        <li>회사는 제1항과 같이 회원으로 가입할 것을 신청한 신청자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다:
          <ul>
            <li>가입신청자가 본 약관 제7조제3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우</li>
            <li>등록 내용에 허위, 기재누락, 오기가 있는 경우</li>
            <li>기타 회원으로 등록하는 것이 회사의 기술상 현저히 지장이 있다고 판단되는 경우</li>
          </ul>
        </li>
      </ol>
      
      <h3>제4장 대출서비스 이용</h3>
      <h4>제6조 (대출신청 및 심사)</h4>
      <ol>
        <li>대출 신청은 회원이 온라인을 통해 필요한 정보를 입력하고 관련 서류를 제출함으로써 이루어집니다.</li>
        <li>회사는 대출 신청에 대해 자체 심사기준에 따라 승인 여부를 결정하며, 심사 과정에서 추가 서류나 정보를 요구할 수 있습니다.</li>
        <li>대출 승인 시 대출조건(금리, 한도, 기간 등)은 회원의 신용도, 담보가치 등을 종합적으로 고려하여 결정됩니다.</li>
      </ol>
      
      <h3>제5장 계약의 해지</h3>
      <h4>제7조 (계약해지 및 이용제한)</h4>
      <ol>
        <li>회원은 언제든지 서비스 이용을 중단하고 회원 탈퇴를 요청할 수 있으며, 회사는 즉시 회원탈퇴를 처리합니다.</li>
        <li>회사는 회원이 다음 각 호의 사유에 해당하는 경우, 사전통지 없이 회원자격을 제한하거나 정지시킬 수 있습니다:
          <ul>
            <li>가입 신청 시에 허위 내용을 등록한 경우</li>
            <li>다른 사람의 서비스 이용을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우</li>
            <li>서비스를 이용하여 법령 또는 본 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우</li>
          </ul>
        </li>
      </ol>
      
      <p><strong>본 약관은 2025년 1월 1일부터 시행됩니다.</strong></p>
    </div>
  `;
}

// 개인정보처리방침 내용 로드
function loadPrivacyContent(container) {
  container.innerHTML = `
    <div class="privacy-intro">
      주식회사 빌리언대부(이하 '회사')는 개인정보보호법에 따라 이용자의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다.
    </div>
    
    <div class="rules-content">
      <h3>제1조 (개인정보의 처리목적)</h3>
      <p>회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
      <ol>
        <li><strong>회원가입 및 관리:</strong> 회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 각종 고지·통지, 고충처리 목적</li>
        <li><strong>재화 또는 서비스 제공:</strong> 대출서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산</li>
        <li><strong>고충처리:</strong> 민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보</li>
        <li><strong>마케팅 및 광고에의 활용:</strong> 신규 서비스(제품) 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공</li>
      </ol>
      
      <h3>제2조 (개인정보의 처리 및 보유기간)</h3>
      <ol>
        <li>회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</li>
        <li>각각의 개인정보 처리 및 보유 기간은 다음과 같습니다:
          <ul>
            <li><strong>회원가입 및 관리:</strong> 회원탈퇴시까지</li>
            <li><strong>재화 또는 서비스 제공:</strong> 재화·서비스 공급완료 및 요금결제·정산 완료시까지</li>
            <li><strong>관련 법령에 따른 보관:</strong> 전자상거래법, 신용정보법 등에 따라 일정기간 보관</li>
          </ul>
        </li>
      </ol>
      
      <h3>제3조 (개인정보의 제3자 제공)</h3>
      <ol>
        <li>회사는 정보주체의 개인정보를 제1조(개인정보의 처리목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</li>
        <li>회사는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다:
          <ul>
            <li><strong>신용평가회사:</strong> 신용조회 목적으로 최소한의 정보만 제공</li>
            <li><strong>금융감독원:</strong> 법령에 의한 금융감독 목적</li>
            <li><strong>국세청:</strong> 세법에 의한 자료제출 의무</li>
          </ul>
        </li>
      </ol>
      
      <h3>제4조 (정보주체의 권리·의무 및 그 행사방법)</h3>
      <ol>
        <li>정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다:
          <ul>
            <li>개인정보 처리현황 통지요구</li>
            <li>개인정보 열람요구</li>
            <li>개인정보 정정·삭제요구</li>
            <li>개인정보 처리정지요구</li>
          </ul>
        </li>
        <li>제1항에 따른 권리 행사는 회사에 대해 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체 없이 조치하겠습니다.</li>
      </ol>
      
      <h3>제5조 (처리하는 개인정보의 항목)</h3>
      <p>회사는 다음의 개인정보 항목을 처리하고 있습니다:</p>
      <ol>
        <li><strong>회원가입 및 관리:</strong> 성명, 생년월일, 아이디, 비밀번호, 주소, 전화번호, 이메일</li>
        <li><strong>대출서비스 제공:</strong> 성명, 주민등록번호, 주소, 전화번호, 직장정보, 소득정보, 신용정보, 계좌정보</li>
        <li><strong>인터넷 서비스 이용과정에서 자동 수집:</strong> IP주소, 쿠키, 서비스 이용기록, 방문기록 등</li>
      </ol>
      
      <h3>제6조 (개인정보 보호책임자)</h3>
      <ol>
        <li>회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다:</li>
        <li><strong>개인정보 보호책임자</strong>
          <ul>
            <li>성명: 차승현</li>
            <li>직책: 개인정보관리책임자</li>
            <li>연락처: 1833-8996, billion_so@zebragroup.co.kr</li>
          </ul>
        </li>
      </ol>
      
      <p><strong>본 방침은 2026년 1월 1일부터 시행됩니다.</strong></p>
    </div>
  `;
}
